import { Tag as ChakraTag } from "@chakra-ui/react";

type TagProps = {
  label: string;
  colorPalette: string;
};

export const Tag = ({ label, colorPalette }: TagProps) => {
  return (
    <ChakraTag.Root
      borderRadius={8}
      paddingBlock={1}
      paddingInline={2}
      variant="subtle"
      size="md"
      colorPalette={colorPalette}
    >
      <ChakraTag.Label fontSize={12} fontWeight={600}>
        {label}
      </ChakraTag.Label>
    </ChakraTag.Root>
  );
};
